import React from 'react';
import axios from 'axios';

import Loading from '../Components/Loading';

import styles from '../styles/DynamicModal.module.css';

const ClaimACaseModal = ({ applicationId, closeModal, onAddAgreement }) => {
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [file, setFile] = React.useState(null);
    const [statusFinal, setStatusFinal] = React.useState('');

    const addAgreement = (e) => {
        e.preventDefault();
        setLoading(true);

        if (file) {
            try {
                const formData = new FormData();
                formData.append('applicationId', applicationId);
                formData.append('file', file);

                axios.put('/api/add-agreement', formData, {
                    headers: { 
                        'Content-Type': 'multipart/form-data',
                        // 'Authorization': `Bearer ${authenticateToken}`
                    },
                }).then(() => {
                    setStatusFinal('Заявка зарегистрирована в системе. После проведения собрания СОАУ Альянс проинформирует вас о решении');
                    onAddAgreement(); // Уведомляем о добавлении
                    setTimeout(() => {
                        closeModal();
                    }, 3400);
                }).catch(error => {
                    setStatus(`Ошибка добавления входящей корреспонденции1 в систему: ${error.response?.data.message || error.message}`);
                }).finally(() => {
                    setLoading(false);
                });
            } catch (error) {
                console.error("Ошибка при добавлении входящей корреспонденции в систему:", error);
                setStatus(`Ошибка добавления входящей корреспонденции в систему: ${error.response?.data.message || error.message}`);
                setLoading(false);
            }
        } else {
            setStatus('Вы не прикрепили файл');
            setLoading(false);
        }
        setTimeout(() => {
            setStatus('');
        }, 2000);
    }
    // Функция для обработки выбора файла
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };
    
    return (
        <div className={styles.liningOver} onClick={() => {closeModal();}}>
            <form className={styles.lining} onClick={(e) => {e.stopPropagation()}} onSubmit={addAgreement}>
                <div className={styles.header}>
                    <div style={{display: 'flex', maxWidth: '80%'}}>
                        <h1>Претендовать на ведение дела</h1>
                    </div>
                    <svg onClick={() => {closeModal();}} viewBox="0 0 24 24" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                    </svg>
                </div>
                <div className={styles.main}>
                    {statusFinal ? <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{statusFinal}</a>
                    : <>
                        <a>Прикрепите файл согласия на ведение (в формате .pdf)</a>
                        <div className={styles.fileAddPanel}>
                            <div className='inputFileContainer'>
                                <input type='file' placeholder='Файл' accept=".pdf" onChange={handleFileChange} />
                            </div>
                        </div>
                        {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
                        {loading ? <Loading /> : <button className='button maxWidth' type='submit'>Отправить согласие</button>}
                    </>}
                </div>
            </form>
        </div>
    )
}

export default ClaimACaseModal;
